var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSociallyValuableOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 1H11.5C5.70101 1 1 5.70101 1 11.5V20.5C1 26.299 5.70101 31 11.5 31H20.5C26.299 31 31 26.299 31 20.5V11.5C31 5.70101 26.299 1 20.5 1Z",
    stroke: "#A5BAB1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7427 15.1503C13.657 15.1431 13.5641 15.1431 13.4713 15.1503C11.5141 15.086 9.96411 13.4789 9.96411 11.5074C9.96411 9.53599 11.5927 7.85742 13.6141 7.85742C15.6355 7.85742 17.2641 9.49314 17.2641 11.5074C17.257 13.4789 15.6998 15.0788 13.7498 15.1503H13.7427Z",
    stroke: "#A5BAB1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6997 9.50684C21.2925 9.50684 22.5782 10.7997 22.5782 12.3854C22.5782 13.9711 21.3425 15.2068 19.8068 15.264C19.7425 15.2568 19.664 15.2568 19.5925 15.264",
    stroke: "#A5BAB1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63553 18.1782C7.64981 19.5068 7.64981 21.6782 9.63553 22.9996C11.8927 24.5139 15.5998 24.5139 17.857 22.9996C19.8427 21.6711 19.8427 19.4996 17.857 18.1782C15.607 16.6711 11.8998 16.6711 9.63553 18.1782Z",
    stroke: "#A5BAB1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2856 22.6503C21.8785 22.5288 22.4356 22.286 22.8928 21.936C24.1714 20.9717 24.1714 19.386 22.8928 18.4288C22.4428 18.086 21.8928 17.8503 21.3071 17.7217",
    stroke: "#A5BAB1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSociallyValuableOff);
export default __webpack_public_path__ + "static/media/socially_valuable_off.939789bde36f8aa115ffdd2eaab7c23a.svg";
export { ForwardRef as ReactComponent };